export default __webpack_public_path__ + "a00f55c.png";